import {
  GetStaticPathsResult,
  GetStaticPropsContext,
  GetStaticPropsResult,
} from 'next';
import {NextSeo} from 'next-seo';

import HeroSection from '@/components/landing/HeroSection';
import UseCasesSection from '@/components/landing/UseCasesSection';
import Layout from '@/components/layout/Layout';

import {Comparison, COMPARISONS_EXTENDED} from '@/content/comparisons';
import ComparisonSection from "@/components/compare/ComparisonSection";
import FeaturesSection, {Feature} from "@/components/landing/FeaturesSection";
import * as React from "react";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import FAQSection from "@/components/landing/FAQSection";
import GetStartedSection from "@/components/landing/GetStartedSection";

export async function getStaticPaths(): Promise<GetStaticPathsResult> {
  const paths = COMPARISONS_EXTENDED.map((comparison) => ({
    params: {slug: comparison.slug},
  }));

  console.log(COMPARISONS_EXTENDED.map((c) => c.slug));

  return {
    paths,
    fallback: false,
  };
}

type CompareToProps = Comparison;

export async function getStaticProps(
  context: GetStaticPropsContext
): Promise<GetStaticPropsResult<CompareToProps>> {
  const slug = context.params?.slug as string;
  if (!slug) {
    return {notFound: true};
  }
  const comparison = COMPARISONS_EXTENDED.find(
    (comparison) => comparison.slug === slug.toLowerCase()
  );
  if (!comparison) {
    return {notFound: true};
  }
  return {
    props: comparison,
  };
}

export default function CompareTo(props: CompareToProps) {
  return (
    <>
      <NextSeo title={props.title} description=''/>
      <Layout>
        <HeroSection
          pageType={props.title}
          titleTop={props.competitors[0].copy.hero_title}
          titleBottom=''
          subtitle={props.competitors[0].copy.hero_subtitle}
        />
        <div className="mt-[100px] mb-10">
          <UseCasesSection title="ClipFM is built for professionals"/>
        </div>
        <FeaturesSection>
          <Feature
            name='Spend less time editing'
            description="Time is your most valuable asset. Simply upload a video and we'll deliver you ready-to-post clips within minutes."
            image='/images/save-time.png'
            alt='Hero image'
          />
          <Feature
            name='Grow your audience'
            description='Clips are a great way to get discovered by new listeners.'
            image='/images/grow-audience-2.png'
            alt='Hero image'
            flipped
          />
          <Feature
            name='Repurpose past videos'
            description='Repackage your existing videos instead of always needing to come up with new content.'
            image='/images/reuse-content.png'
            alt='Hero image'
          />
          <Feature
            name='Spend less money'
            description='Pay less than 10x the price of what it costs to hire an editor.'
            image='/images/lower-price-4.png'
            alt='Hero image'
            flipped
          />
        </FeaturesSection>
        <ComparisonSection competitors={props.competitors} />
        <GetStartedSection />
        {/*<TestimonialsSection />*/}
        <FAQSection />
      </Layout>
    </>
  );
}
